/* eslint-env browser */
import DOMPurify from 'dompurify';

const getTextFromHTML = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

const sanitizeUrl = (url) => {
    return DOMPurify.sanitize(url);
};

export { getTextFromHTML, sanitizeUrl };
